import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function Sustainability({ susFinInnoRisk = [] }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const allMetrics = [
    // { key: "initiatives", label: "Initiatives" },
    { key: "emission_reduction_targets", label: "Emission Reduction Targets" },
    { key: "certifications", label: "Certifications" },
    // { key: "progress_status", label: "Progress Status" },
    // { key: "benchmarking_vs_industry", label: "Benchmarking vs Industry" },
    // { key: "forward_outlook", label: "Forward Outlook" },
  ];

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(susFinInnoRisk);
    setTabData(transformed);
    // console.log("SUSTAINABILITY: " + JSON.stringify(transformed));
    setTableBelowDescription(
      <ParsedTextWithLinks
        text={susFinInnoRisk?.[0]?.response?.tableComments || ""}
      />
    );
  }, [susFinInnoRisk]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Sustainability"
      subtitle=""
      data={tabData}
      metrics={allMetrics}
      rowIdentifier="initiatives"
      // belowTableDescription={tableBelowDescription}
      belowTableDescription={""}
      actions={actions}
    />
  );
}

export default Sustainability;
